module.exports = __webpack_public_path__ + "static/media/banner.75bb73e6.png";